<template>
  <div class="custom-popup">
    <table>

      <tr>
        <td>status</td>
        <td>{{ point.status}}</td>
      </tr>

      <tr>
        <td>time</td>
        <td>{{ point.time}}</td>
      </tr>
      <tr>
        <td>code</td>
        <td>{{ point.code}}</td>
      </tr>

      <tr>
        <td>tag</td>
        <td>{{ point.tag}}</td>
      </tr>

    </table>
  </div>
</template>

<script>
export default {
  name: 'PointPopup',
  props: {
    point: {
      type: Object,
      required: true
    }
  }
}
</script>

<style scoped>

</style>
